import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        TankDynamixLabs
      </header>
    </div>
  );
}

export default App;
